<template>
	<div :class="isLockedCard && 'd-flex justify-space-between'">
		<div v-if="isLockedCard" class="fieldFore--text fs--12 fw--500 mr-2">
			<img
				v-if="lockImage"
				:src="lockImage"
				class="lock-icon cursor-pointer"
				title="Subscribe to reactivate"
				@click="$router.push('/premium')" />
			<span class="cursor-pointer" @click="$router.push('/premium')">Subscribe to reactivate</span>
		</div>
		<v-chip v-if="item.subTier > 0" :color="chipColorClass" class="mt-1" small>
			<span class="fw--500" :class="textColorClass">{{ textLabel }}</span>
		</v-chip>
	</div>
</template>

<script>
import { computed } from '@vue/composition-api';
import store from '@/store';
import { SubPlan } from '@/utils/constants.js';
import lock_plus from '@/assets/icons/lock_plus.png';
import lock_premium from '@/assets/icons/lock_premium.png';
import lock_extreme from '@/assets/icons/lock_extreme.png';

export default {
	props: {
		// Either sticker or voice object may be passed. They have the same
		// subTier property, but we have two properties for readability.
		sticker: {
			type: Object,
			default: null,
		},
		voice: {
			type: Object,
			default: null,
		},
		isLockedCard: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		// The item is either a sticker or a voice.
		const item = computed(() => props.sticker || props.voice);

		// Subscription plan related to the item.
		const itemSubPlan = computed(() => store.state.app.subPlans.find(plan => plan.tier === item.value.subTier));

		const chipColorClass = computed(() => (itemSubPlan.value ? itemSubPlan.value.primaryColor : 'white'));

		const textColorClass = computed(() => {
			if (itemSubPlan.value) {
				if (itemSubPlan.value.tier == SubPlan.PREMIUM) {
					return 'black--text';
				} else if (itemSubPlan.value.tier == SubPlan.PLUS) {
					return 'black--text';
				} else if (itemSubPlan.value.tier == SubPlan.EXTREME) {
					return 'white--text';
				}
			}

			return 'white--text';
		});

		const textLabel = computed(() => {
			if (itemSubPlan.value) {
				if (itemSubPlan.value.tier == SubPlan.PREMIUM) {
					return 'Premium';
				} else if (itemSubPlan.value.tier == SubPlan.PLUS) {
					return 'Premium Plus';
				} else if (itemSubPlan.value.tier == SubPlan.EXTREME) {
					return 'Premium Xtreme';
				}
			}

			return 'Standard';
		});

		const lockImage = computed(() => {
			if (itemSubPlan.value) {
				if (itemSubPlan.value.tier == SubPlan.PREMIUM) {
					return lock_premium;
				} else if (itemSubPlan.value.tier == SubPlan.PLUS) {
					return lock_plus;
				} else if (itemSubPlan.value.tier == SubPlan.EXTREME) {
					return lock_extreme;
				}
			}

			return null;
		});

		return {
			SubPlan,
			item,
			chipColorClass,
			textColorClass,
			textLabel,
			lockImage,
		};
	},
};
</script>

<style lang="scss" scoped>
.lock-icon {
	width: 20px;
	height: 20px;
	margin-right: 10px;
}
</style>
